import { l10nEnService } from '@uplift/services';
import { InsuranceCompany } from '@uplift/types';
import { sessionPay, sessionPayUUID } from './network-preferences.constant';

export const cashPay = {
  id: sessionPayUUID,
  humanId: sessionPay,
  name: l10nEnService.onboarding.insurance.sessionPay,
  logo: '',
};

export const sessionPayCompany: InsuranceCompany = {
  id: sessionPayUUID,
  name: l10nEnService.onboarding.insurance.sessionPay,
  logo: '',
  createdAt: '',
  shortName: l10nEnService.onboarding.insurance.selfPay,
  updatedAt: '',
  url: '',
  key: ''
};
